import { NgModule } from '@angular/core';

import { ButtonModule } from '../button/button.module';
import { GroupModule } from './../group/group.module';
import { IconModule } from './../icon/icon.module';
import { PaginationComponent } from './pagination.component';

@NgModule({
  declarations: [PaginationComponent],
  exports: [PaginationComponent],
  imports: [GroupModule, ButtonModule, IconModule],
})
export class PaginationModule {}
export { PaginationComponent } from './pagination.component';
